import {
  DIM2CLASS
} from '../core/icon-class';

import {
  PATH_STRING_SEPARATOR
} from '../common/config.js';

// import {
//   AlertModalController
// } from './editor/alert-modal.component';

require('./filter-dimension.component.scss');

class FilterDimensionController {
  constructor(
    $scope,
    $q,
    $element,
    $timeout,
    $http,
    $modal,
    CurrentFilterService,
    AggregateDataService,
    CurrentModelService,
    $rootScope,
    ErrorHandlerService,
    RouterService,
    CurrentFilterDataService,
    PermissionService,
    FilterResource,
    LayoutService,
  ) {
    this.$scope = $scope;
    this.$http = $http;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$modal = $modal;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = DIM2CLASS;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.ErrorHandlerService = ErrorHandlerService;
    this.router = RouterService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.permission = PermissionService;
    this.FilterResource = FilterResource;
    this.panelWidth = 1000;
    this.LayoutService = LayoutService;
    this.$scope.$on('splitter1Changed', (e, d) => this.updatePanelWidth(e));
    this.$scope.$on('splitter2Changed', (e, d) => this.updatePanelWidth(e));
    this.updateAggregate = this.updateAggregate.bind(this);

    this.startUpdateAggregate = () => {
      if (this.timerId) this.$timeout.cancel(this.timerId);
      const renewTime = this.LayoutService && this.LayoutService.options.renewAggregateSeconds.value * 1000;
      if (renewTime) this.timerId = this.$timeout(this.updateAggregate, renewTime);
    };

    this.$scope.$on('init', (e, d) => {
      this.updatePanelWidth(e, d);
      this.startUpdateAggregate();
    });

    this.$scope.$on('optionsChanged', (e, d) => this.startUpdateAggregate());
  }

  updateAggregate() {
    const renewTime = this && this.LayoutService && this.LayoutService.options.renewAggregateSeconds.value * 1000;
    if (renewTime) {
      this.AggregateDataService.aggregateCheck(this.findScreenDimIndex());
    }
    this.timerId = this.$timeout(this.updateAggregate, renewTime);
  }

  findScreenDimIndex() {
    const drill = this.currentFilter.filterBar.drilldown[0];
    if (drill !== 'agent_agent@computer_name:computer_name' &&
      drill !== 'agent_account@user_name:user_name') return 0;
    const ch = this.$element.find('sc-filter-dimension-node .nav-list').children();
    let index = 0;
    ch.each(i => {
      index = i;
      return $(ch[i]).offset().top < 0;
    });
    return index;
  }

  updatePanelWidth(e) {
    this.panelWidth = this.$element[0].offsetWidth;
    if (e.targetScope.$$phase) return;
    this.$scope.$digest();
  }

  get panel() {
    return this.currentFilter.panel;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  get showRemote() {
    return this.filterBar.drilldown[0] === 'agent_agent@computer_name:computer_name' || this.filterBar.drilldown[0] === 'agent_account@user_name:user_name';
  }

  get aggregate() {
    return this.AggregateDataService.aggregate;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get isLoading() {
    return this.AggregateDataService.loading;
  }

  get isLoadingMore() {
    return this.AggregateDataService.loadingMore;
  }

  selectAll(cmd) {
    if (!this.aggregate || !this.aggregate.cells) {
      return;
    }
    const drill = this.filterBar.drilldown[0];
    const cells = this.AggregateDataService.aggregate.cells;
    cells.forEach(cell => {
      const filter = this.model.getCellFilter(drill, cell);
      if (cmd === 'select all') this.filter.addCut(filter);
      else if (cmd === 'deselect all') this.filter.removeFilter(filter.dimension, filter.value);
      else this.filter.toggleFilter(filter);
    });
    this.currentFilter.rebuildVisibleDimensions();
    this.router.filterChanged();
  }

  searchAggregate(event) {
    if (event && event.keyCode !== 13) {
      return false;
    }
    this.router.lookup(this.filterBar.lookup);
  }

  aggregate_more() {
    if (!this.filter || !this.filterBar) {
      return;
    }
    return this.AggregateDataService.aggregate_more(false);
  }

  toggleSkipStat() {
    this.filterBar.toggleSkipStat();
    return this.AggregateDataService.init(false);
  }

  toggleAutoUpdate() {
    this.CurrentFilterDataService.autoUpdate = !this.CurrentFilterDataService.autoUpdate;
    if (this.CurrentFilterDataService.autoUpdate) {
      this.$scope.$root.$broadcast('reload');
    }
  }

  hasCellFilter(cell) {
    const filter = this.model.getCellFilter(this.filterBar.drilldown[0], cell);
    return this.filter.hasFilter(filter);
  }

}

export const FilterDimensionComponent = {
  template: require('./filter-dimension.component.html'),
  controller: FilterDimensionController,
};



// WEBPACK FOOTER //
// ./src/filter/filter-dimension.component.js